import { phoneNumber, supportEmail } from '../../../configs/ContactConfig';

export default {
  workspace: {
    recommendedForYou: {
      title: 'Recommended For You',
    },
    workspaces: {
      title: 'Workspaces',
    },
  },
  limitComponentMessage: '%{componentName} already exist',
  quickAccessComponentTitle: 'Quick Access components',
  quickAccess: {
    Watchlist: 'Watchlist',
    MarketInDepth: 'Market In-depth',
    MarketCalendar: 'Market Calendar',
    MoneyFlow: 'Money Flow',
    TimeAndSales: 'Time & Sales',
    PriceDepth: 'Price Depth',
    Charting: 'Technical Chart',
    News: 'News Aggregator',
    FASnapshot: 'Company Snapshot',
    FinancialAnalysis: 'Financial Analysis',
    QuoteMovement: 'Quote Movement',
    ConsensusAnalysis: 'Consensus',
    OwnerShip: 'OwnerShip',
    Valuation: 'Valuation',
    PriceData: 'Price Data',
  },
  openWidget: 'Open Widget',
  noMatchedStock: 'No Matched Stock',
  addToHeadLine: 'Add to headline',
  createWorkspace: 'Create workspace',

  tooltipSideBar: {
    SAVE_CURRENT_WORKSPACE: 'Save Current Workspace',
    REFRESH_WORKSPACE: 'Refresh Workspace',
    DOWNLOAD_EXCEL_FORMAT: 'Download Excel Format',
    GENERAL_SETTING: 'General Setting',
    OPEN_WORKSPACE: 'Open Workspace',
    OPEN_A_COMPONENT: 'Open a Component',
  },

  notComeOut: {
    title: 'Function is underconstruction',
    message: 'We will inform you when it is ready.  Please try again later.',
  },

  logout: {
    title: 'Logout Confirmation',
    message: 'Are you sure you want logout from FiinTrade',
  },
  anotherLogin: 'Another Login',
  anotherLoginLineMessage: `Your account already logged in from another device. If not you, immediately change your login password to protect your account. <div style="margin-top: 10px"/>
    Contact Customer Service Center
      <a href="tel:${phoneNumber}"><span style="color: #60bef1;">${phoneNumber}</span></a>
     or email <a href="mailto:${supportEmail}"><span style="color: #60bef1;">${supportEmail}</span></a>
     for assistance when needed.
  `,
  sessionTimeout: 'Session Timeout',
  sessionTimeoutMessage: `
    Because of confidentiality, accounts will be logged out every 8 hours. <div style="margin-top: 10px"/>
    You will automatically return to the login interface after %{seconds} seconds
  `,
  expireTextLineOne:
    'Your account has expired. Please select the personal information to renew.',
  expireTextLineTwo: ` Contact Customer Service Center
      <a href="tel:${phoneNumber}"><span style="color: #60bef1;">${phoneNumber}</span></a>
     or email <a href="mailto:${supportEmail}"><span style="color: #60bef1;">${supportEmail}</span></a>
     for assistance when needed.`,
  timeoutAPI: 'Error Loading Data',
  timeoutAPIMessage: `Unable to load data. Please try again after seconds.`,
  saveSettingMessage: 'The changes were saved successfully',
  changeLogs: 'Update',
  syncComponent: 'Sync component',
  guest: {
    message: 'You are not authorized to access this function.',
    contact: 'Contact: ',
    please: 'Please ',
    toAccess: ' your account in order to access this feature!',
    hotline: 'Hotline: ',
    hasAccount: 'You have an account?',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    upgrade: 'Upgrade',
    guestFullText:
      'Please Sign In your account in order to access this feature!',
    expiredFullText:
      'Please upgrade your account in order to access this feature!',
  },
  continue: 'Continue',
};
